module.exports = __webpack_public_path__ + "img/zoom-out.b0ea8e50.svg";